import { IconSize } from "shared/types/Icon"
import { Icon } from "shared/ui/icon/Icon"
import { IconName } from "shared/ui/icon/__generated__/IconName"

export function AccordionIndicator() {
  return (
    <Icon
      name={IconName.SMALL_CARET_UP}
      size={IconSize.XXS}
      className="accordion-button__indicator"
    />
  )
}
